import CartServiceSelector from '../components/CartServiceSelector';
import CartAppointmentForm from '../components/CartAppointmentForm';
import { OrderSliderForms } from '../model/CartModel';
import type { PropertyCartItem } from '../types/cart.types';

interface ServiceAccessSliderProps {
  type: OrderSliderForms;
  data: PropertyCartItem;
  onContinueAction: (data: PropertyCartItem) => void;
  onDoneAction: (data: PropertyCartItem) => void;
  onServiceAction: (data: PropertyCartItem) => void;
}

const ServiceAccessSlider = ({
  type,
  data,
  onContinueAction,
  onDoneAction,
  onServiceAction,
}: ServiceAccessSliderProps) => (
  <div className="flex h-full min-h-0 flex-1 flex-col">
    {type === OrderSliderForms.SERVICES && (
      <CartServiceSelector data={data} onContinue={onContinueAction} />
    )}
    {type === OrderSliderForms.ACCESSINFO && (
      <CartAppointmentForm
        data={data}
        onDone={onDoneAction}
        onBack={onServiceAction}
      />
    )}
  </div>
);

export default ServiceAccessSlider;
